const interopDefault = (mod) => mod.default || mod;

export { interopDefault };
